
export enum SeatObjectState {
    Free = 'Free',
    Sold = 'Sold',
    Scanned = 'Scanned',
    TicketScanned = 'TicketScanned',
    PassScanned = 'PassScanned',
    InCart = 'InCart',
    Locked = 'Locked',
    ReservedForPass = 'ReservedForPass',
    ReservedByPass = 'ReservedByPass',
    LockedByPass = 'LockedByPass',
    ReservedForTicket = 'ReservedForTicket',
    Disabled = 'Disabled',
    NotConfigured = 'NotConfigured',
}
